"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/types");
function showReadinessCheck() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.SET_SHOW_READINESS_CHECK) {
    return action.payload;
  }
  return state;
}
var _default = exports["default"] = showReadinessCheck;